// Detects whether an input string looks like a direct paper identifier
// (arXiv ID, DOI, or paper URL) vs. a free-text keyword query.
//
// The PaperLookup modal and the home page search hero both feed user input
// through here to decide which of two behaviors to offer:
//   - 'id'      → fetch the paper directly by ID/URL (/paper/<id>)
//   - 'keyword' → run a keyword search across today's papers (/today?q=...)
//   - 'empty'   → the input is blank
export function detectLookupMode(input) {
  const trimmed = (input || '').trim();
  if (!trimmed) return 'empty';

  // Full URLs, or hostnames of known paper sources embedded anywhere
  if (/^https?:\/\//i.test(trimmed)) return 'id';
  if (/\b(arxiv\.org|biorxiv\.org|medrxiv\.org|psyarxiv\.com|osf\.io)\b/i.test(trimmed)) return 'id';

  // Modern arXiv IDs: YYMM.NNNNN with optional version
  if (/^\d{4}\.\d{4,6}(v\d+)?$/.test(trimmed)) return 'id';

  // Legacy arXiv IDs: archive/subject + 7-digit number, optional version
  if (/^[a-z-]+(\.[A-Z]{2})?\/\d{7}(v\d+)?$/i.test(trimmed)) return 'id';

  // DOIs (bioRxiv / psyArXiv / etc.) — 10.NNNN/...
  if (/^10\.\d{4,9}\//.test(trimmed)) return 'id';

  return 'keyword';
}
